function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { orderStatusNumApi, orderListApi, orderLogApi, orderMarkApi, orderDeleteApi, orderPrint, orderDetailApi, writeUpdateApi, orderExcelApi, orderPrintReceiptApi, writeUpdateTicketApi, freeActivityCancelApi, freeActivityVerificationPreviewApi, freeActivityVerifyApi } from '@/api/order';
import detailsFrom from './components/orderDetail';
import orderSend from './orderSend';
import Cookies from 'js-cookie';
import { isWriteOff } from '@/utils';
import { checkPermi } from '@/utils/permission';
import DirectRefund from '@/views/order/components/directRefund.vue';
import FreeActivityQuantityDialog from './components/freeActivityQuantityDialog.vue';
import FreeActivityVerifyDialog from './components/freeActivityVerifyDialog.vue';
import * as $constants from '@/utils/constants';
import { handleDeleteTable } from '@/libs/public'; // 权限判断函数
var tableFroms = {
  status: 'all',
  dateLimit: '',
  orderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  type: '',
  searchType: 'all',
  content: ''
};
export default {
  name: 'orderlistDetails',
  components: {
    DirectRefund: DirectRefund,
    detailsFrom: detailsFrom,
    orderSend: orderSend,
    FreeActivityQuantityDialog: FreeActivityQuantityDialog,
    FreeActivityVerifyDialog: FreeActivityVerifyDialog
  },
  data: function data() {
    return {
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      merchant: JSON.parse(localStorage.getItem('User_MerchantInfo')) || {},
      fromType: [{
        value: '',
        text: '全部'
      }, {
        value: '0',
        text: '普通'
      }, {
        value: '1',
        text: '秒杀'
      }, {
        value: '2',
        text: '拼团'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: isWriteOff(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['订单号', '用户昵称', '实际支付', '支付方式', '订单状态', '核销时间', '下单时间'],
      columnData: ['订单号', '用户昵称', '实际支付', '支付方式', '订单状态', '核销时间', '下单时间'],
      isIndeterminate: true,
      orderDatalist: null,
      merPrintStatus: Cookies.get('merPrint'),
      // 商家小票打印开关状态
      dialogVisibleDirectRefund: false,
      secondType: 0,
      //订单二级类型:0-普通订单，1-积分订单，2-虚拟订单，4-视频号订单，5-云盘订单，6-卡密订单
      type: 0,
      //订单类型
      freeActivityCancelVisible: false,
      freeActivityVerifyVisible: false,
      freeActivitySubmitting: false,
      freeActivityCancelState: {},
      freeActivityVerifyState: {},
      freeActivityVerifyCode: '',
      freeActivityError: ''
    };
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:order:page:list'])) this.getList();
    if (checkPermi(['merchant:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: checkPermi,
    formatFreeActivitySummary: function formatFreeActivitySummary(row) {
      return '总 ' + Number(row.totalNum || 0) + ' · 已核销 ' + Number(row.verifiedNum || 0) + ' · 已取消 ' + Number(row.cancelledNum || 0) + ' · 剩余 ' + Number(row.remainingNum || 0);
    },
    formatFreeActivityStatus: function formatFreeActivityStatus(row) {
      var status = {
        WAITING: '待核销',
        PARTIAL: '待核销',
        CANCELLED: '已取消',
        VERIFIED: '已核销',
        COMPLETED_MIXED: '已完成'
      };
      return status[row.reservationStatus] || '-';
    },
    openFreeActivityCancel: function openFreeActivityCancel(row) {
      this.freeActivityCancelState = _objectSpread({}, row);
      this.freeActivityError = '';
      this.freeActivityCancelVisible = true;
    },
    closeFreeActivityCancel: function closeFreeActivityCancel() {
      if (!this.freeActivitySubmitting) this.freeActivityCancelVisible = false;
    },
    confirmFreeActivityCancel: function () {
      var _confirmFreeActivityCancel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(operation) {
        var result, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.freeActivitySubmitting = true;
              this.freeActivityError = '';
              _context.p = 1;
              _context.n = 2;
              return freeActivityCancelApi(_objectSpread({
                orderNo: this.freeActivityCancelState.orderNo
              }, operation));
            case 2:
              result = _context.v;
              this.freeActivityCancelState = _objectSpread(_objectSpread({}, this.freeActivityCancelState), result.currentState || {});
              this.freeActivityCancelVisible = false;
              _context.n = 3;
              return this.refreshAllOrderState();
            case 3:
              this.$message.success('取消预约成功');
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (_t.currentState) this.freeActivityCancelState = _objectSpread(_objectSpread({}, this.freeActivityCancelState), _t.currentState);
              this.freeActivityError = _t.message || '取消预约失败';
            case 5:
              _context.p = 5;
              this.freeActivitySubmitting = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function confirmFreeActivityCancel(_x) {
        return _confirmFreeActivityCancel.apply(this, arguments);
      }
      return confirmFreeActivityCancel;
    }(),
    //直接退款
    onDirectRefund: function onDirectRefund(row) {
      this.orderNo = row.orderNo;
      this.type = row.type;
      this.dialogVisibleDirectRefund = true;
    },
    //直接退款关闭
    handlerSuccessClose: function handlerSuccessClose() {
      this.dialogVisibleDirectRefund = false;
    },
    //直接退款成功回调
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.dialogVisibleDirectRefund = false;
      this.getList();
    },
    // 核销订单
    onWriteOff: function () {
      var _onWriteOff = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var verifyCode, state, _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.$modalPrompt('text', '核销订单', null, '核销码');
            case 1:
              verifyCode = _context2.v;
              if (verifyCode) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return freeActivityVerificationPreviewApi({
                verifyCode: verifyCode
              });
            case 3:
              state = _context2.v;
              this.freeActivityVerifyCode = verifyCode;
              this.freeActivityVerifyState = state;
              this.freeActivityError = '';
              this.freeActivityVerifyVisible = true;
              return _context2.a(2);
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              if (!(_t2.businessCode !== 'FREE_ACTIVITY_ORDER_NOT_ELIGIBLE')) {
                _context2.n = 5;
                break;
              }
              this.$message.error(_t2.message || '核销失败，请重试');
              return _context2.a(2);
            case 5:
              if (!(this.merchant.merchantType === 30)) {
                _context2.n = 7;
                break;
              }
              _context2.n = 6;
              return writeUpdateTicketApi({
                verifyCode: verifyCode
              });
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.n = 8;
              return writeUpdateApi({
                verifyCode: verifyCode
              });
            case 8:
              _context2.n = 9;
              return this.refreshAllOrderState();
            case 9:
              this.$message.success('核销成功');
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t3 = _context2.v;
              // 可以针对接口异常或用户取消做不同提示，这里简单统一处理
              this.$message.error('核销失败，请重试');
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4], [0, 10]]);
      }));
      function onWriteOff() {
        return _onWriteOff.apply(this, arguments);
      }
      return onWriteOff;
    }(),
    closeFreeActivityVerify: function closeFreeActivityVerify() {
      if (!this.freeActivitySubmitting) {
        this.freeActivityVerifyVisible = false;
        this.freeActivityVerifyCode = '';
      }
    },
    confirmFreeActivityVerify: function () {
      var _confirmFreeActivityVerify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(operation) {
        var result, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.freeActivitySubmitting = true;
              this.freeActivityError = '';
              _context3.p = 1;
              _context3.n = 2;
              return freeActivityVerifyApi(_objectSpread({
                orderNo: this.freeActivityVerifyState.orderNo,
                verifyCode: this.freeActivityVerifyCode
              }, operation));
            case 2:
              result = _context3.v;
              this.freeActivityVerifyState = _objectSpread(_objectSpread({}, this.freeActivityVerifyState), result.currentState || {});
              this.freeActivityVerifyVisible = false;
              this.freeActivityVerifyCode = '';
              _context3.n = 3;
              return this.refreshAllOrderState();
            case 3:
              this.$message.success('核销成功');
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t4 = _context3.v;
              if (_t4.currentState) this.freeActivityVerifyState = _objectSpread(_objectSpread({}, this.freeActivityVerifyState), _t4.currentState);
              this.freeActivityError = _t4.message || '核销失败，请重试';
            case 5:
              _context3.p = 5;
              this.freeActivitySubmitting = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4, 5, 6]]);
      }));
      function confirmFreeActivityVerify(_x2) {
        return _confirmFreeActivityVerify.apply(this, arguments);
      }
      return confirmFreeActivityVerify;
    }(),
    refreshAllOrderState: function refreshAllOrderState() {
      return Promise.all([this.getList(), this.getOrderStatusNum(), this.$refs.orderDetail ? this.$refs.orderDetail.reloadIfOpen() : Promise.resolve()]);
    },
    handleReset: function handleReset() {
      this.tableFrom.type = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.page = 1;
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.selectChange();
    },
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      return Promise.all([this.getList(), this.getOrderStatusNum()]);
    },
    // 发送
    sendOrder: function sendOrder(row) {
      var _this = this;
      if (row.isLogoff) {
        this.$modalSure('当前用户已注销，有责发货！').then(function () {
          _this.onSend(row);
        });
      } else {
        if (row.refundStatus == 1) return this.$message.error('请先处理售后，再进行发货/核销操作');
        this.onSend(row);
      }
    },
    handlePrintReceipt: function handlePrintReceipt(row) {
      var _this2 = this;
      this.$modalSure('确认打印小票').then(function () {
        orderPrintReceiptApi(row.orderNo).then(function (data) {
          _this2.$message.success('小票打印成功');
        });
      });
    },
    //发货操作
    onSend: function onSend(row) {
      this.secondType = row.secondType;
      this.orderNo = row.orderNo;
      this.$refs.send.modals = true;
      //this.$refs.send.getList();
      this.$refs.send.orderProDetail(row.orderNo);
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this3 = this;
      if (row.isDel) {
        this.$modalSure().then(function () {
          orderDeleteApi({
            orderNo: row.orderNo
          }).then(function () {
            _this3.$message.success('删除成功');
            handleDeleteTable(_this3.tableData.data.length, _this3.tableFrom);
            _this3.getList();
            _this3.getOrderStatusNum();
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderNo = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.getOrderInvoiceList(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    getDetail: function getDetail(id) {
      var _this4 = this;
      this.loading = true;
      orderDetailApi(id).then(function (res) {
        _this4.orderDatalist = res;
        _this4.loading = false;
      }).catch(function () {
        _this4.orderDatalist = null;
        _this4.loading = false;
      });
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this5 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      orderLogApi(this.tableFromLog).then(function (res) {
        _this5.tableDataLog.data = res.list;
        _this5.tableDataLog.total = res.total;
        _this5.LogLoading = false;
      }).catch(function () {
        _this5.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this6 = this;
      this.$modalPrompt('textarea', '备注', row.merchantRemark, '订单备注').then(function (V) {
        orderMarkApi({
          remark: V,
          orderNo: row.orderNo
        }).then(function () {
          _this6.$message.success('操作成功');
          _this6.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this7 = this;
      this.listLoading = true;
      return orderListApi(this.tableFrom).then(function (res) {
        _this7.tableData.data = res.list || [];
        _this7.tableData.total = res.total;
        _this7.listLoading = false;
        _this7.checkedCities = _this7.$cache.local.has('order_stroge') ? _this7.$cache.local.getJSON('order_stroge') : _this7.checkedCities;
      }).catch(function () {
        _this7.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this8 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.status;
      return orderStatusNumApi(data).then(function (res) {
        _this8.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      orderExcelApi(data).then(function (res) {
        // 使用域名，不带/api
        var baseUrl = process.env.VUE_APP_BASE_API.replace(/\/api$/, '');
        var fileName = res.fileName.startsWith('/') ? res.fileName : '/' + res.fileName;
        window.open(baseUrl + fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this9 = this;
      orderPrint(data.orderNo).then(function (res) {
        _this9.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this9.$modal.msgError(error.message);
      });
    }
  }
};